export function BrandLogos() {
  return (
    <div className="absolute bottom-4 left-3 z-10 hidden items-center gap-2 border bg-background/95 px-3 py-2 text-xs shadow-sm backdrop-blur lg:flex">
      <a
        className="font-medium underline underline-offset-3"
        href="https://github.com/valhalla/web-app"
        target="_blank"
        rel="noreferrer"
      >
        Valhalla Web App fork
      </a>
      <span aria-hidden="true">·</span>
      <span>maps.prawel.pl</span>
    </div>
  );
}
